import React, {useState, useEffect} from "react";
import FilterableDashboardTemplate from "../../components/dashboardlayouts/FilterableDashboardTemplate";
import AmChartRingIndicator from "../../components/AmChartRingIndicator";
import DashboardRow from "../../components/dashboardlayouts/DashboardRow";
import DashboardCarousel from "../../components/dashboardlayouts/DashboardCarousel";
import RightDrawer from "../../components/dashboardlayouts/RightDrawer";
import MetricInsightBar from "./components/MetricInsightBar";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import {CARD_STYLE_STRETCH} from "../../constants/styles";
import AmBarChart from "../../components/AmBarChart";
import AmHeatmapChart from "../../components/AmHeatmapChart";
import ChartCard from "../../components/ChartCard";
import BookingUtilisationTimelineDemo from "./components/BookingUtilisationTimelineDemo";
import WorksettingPerformanceDrawer from "./components/WorksettingPerformanceDrawer";
import {
	  METRIC_ACCURACY,
	  METRIC_NO_SHOW,
	  METRIC_WORKSTATION,
	  METRIC_EFFICIENCY
	} from "../../constants/metrics";
import { METRIC_CONFIG } from "../../constants/metric-config";

export default function WorksettingPerformance(){
	

	const [selectedMetric, setSelectedMetric] = useState(METRIC_ACCURACY);
	const [groupBy, setGroupBy] = useState("room");
	const [mode, setMode] = useState("top"); // or "bottom"
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [selectedName, setSelectedName] = useState(null);
	
	const [filter, setFilter] = useState({
		    buildingId: -100,
		    floorId: -100,
		    floorZoneId: -100,
		    organisationId: -100,
		    coreDayOnly: false,
		    startDate: null,
		    endDate: null
		});
		
		if (filter == null) {
		    filter = new RoomBookingFilter();
		}
	
	
	const dayOfWeekData = [
	  { category: "Mon", value: 72 },
	  { category: "Tue", value: 81 },
	  { category: "Wed", value: 65 },
	  { category: "Thu", value: 78 },
	  { category: "Fri", value: 59 }
	];
	
	
	const hourOfDayData = [
	  { category: "08", value: 30 },
	  { category: "09", value: 55 },
	  { category: "10", value: 72 },
	  { category: "11", value: 68 },
	  { category: "12", value: 40 },
	  { category: "13", value: 35 },
	  { category: "14", value: 60 },
	  { category: "15", value: 70 },
	  { category: "16", value: 52 },
	  { category: "17", value: 28 }
	];
	
	
	const heatmapData = [];

	const days = ["Fri2", "Thu2", "Wed2", "Tue2", "Mon2", "Fri1", "Thu1", "Wed1", "Tue1", "Mon1"];
	const hours = ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17"];

	days.forEach(day => {
	  hours.forEach(hour => {
	    heatmapData.push({
	      day: day,
	      hour: hour,
	      value: Math.floor(Math.random() * 100)
	    });
	  });
	});
	
	
	const panelStyle = {
	  background: "linear-gradient(145deg, #0f0f0f, #1a1a1a)",
	  borderRadius: "10px",
	  padding: "18px 20px",
	  boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
	  display: "flex",
	  flexDirection: "column",
	  justifyContent: "center",
	  height: "120px",
	  position: "relative",
	  overflow: "hidden",
	  width:'200px'
	};
	
	
	const sheen = {
	  position: "absolute",
	  top: 0,
	  left: "-50%",
	  width: "200%",
	  height: "100%",
	  background: "linear-gradient(120deg, transparent, rgba(255,255,255,0.06), transparent)",
	  transform: "skewX(-20deg)"
	};
	
	
	const rowStyle = {
	  display: "flex",
	  justifyContent: "space-between",
	  gap: "20px"
	};
	
	const divider = {
	  height: "1px",
	  background: "rgba(255,255,255,0.08)",
	  margin: "12px 0"
	};
	
	
	const tabContainer = {
	  display: "flex",
	  gap: "8px",
	  marginBottom: "10px"
	};

	const tab = {
	  padding: "4px 10px",
	  borderRadius: "6px",
	  fontSize: "11px",
	  cursor: "pointer",
	  background: "#f0f0f0"
	};

	const activeTab = {
	  background: "#222",
	  color: "#fff"
	};

	const switchContainer = {
	  display: "flex",
	  borderRadius: "8px",
	  overflow: "hidden",
	  background: "#eee"
	};

	const switchItem = {
	  padding: "4px 10px",
	  fontSize: "11px",
	  cursor: "pointer"
	};

	const activeSwitch = {
	  background: "#222",
	  color: "#fff"
	};
	
	
	const offendersData = [
	  { category: "Room A101", value: 92 },
	  { category: "Room B204", value: 88 },
	  { category: "Room C310", value: 84 },
	  { category: "Room D115", value: 79 },
	  { category: "Room E220", value: 75 },
	  { category: "Room F018", value: 72 },
	  { category: "Room G402", value: 69 },
	  { category: "Room H109", value: 65 },
	  { category: "Room J305", value: 61 },
	  { category: "Room K210", value: 58 }
	];
	
	
	const topBottomData = {

	  room: {
	    top: [
	      { category: "Room A101", value: 95 },
	      { category: "Room B204", value: 91 },
	      { category: "Room C310", value: 88 }
	    ],
	    bottom: [
	      { category: "Room X001", value: 12 },
	      { category: "Room Y002", value: 18 },
	      { category: "Room Z003", value: 21 }
	    ]
	  },

	  team: {
	    top: [
	      { category: "Finance", value: 90 },
	      { category: "Engineering", value: 87 },
	      { category: "Sales", value: 84 }
	    ],
	    bottom: [
	      { category: "HR", value: 22 },
	      { category: "Legal", value: 25 },
	      { category: "Admin", value: 28 }
	    ]
	  },

	  floor: {
	    top: [
	      { category: "Floor 3", value: 93 },
	      { category: "Floor 5", value: 89 }
	    ],
	    bottom: [
	      { category: "Floor 1", value: 30 },
	      { category: "Floor 2", value: 35 }
	    ]
	  },

	  type: {
	    top: [
	      { category: "Meeting Room", value: 91 },
	      { category: "Focus Booth", value: 85 }
	    ],
	    bottom: [
	      { category: "Collab Space", value: 40 },
	      { category: "Hot Desk", value: 45 }
	    ]
	  }

	};
	
	
	const groupByData = {
	  department: [
	    { category: "Finance", value: 72 },
	    { category: "Engineering", value: 81 },
	    { category: "Sales", value: 65 },
	    { category: "HR", value: 58 }
	  ],
	  team: [
	    { category: "Team Alpha", value: 78 },
	    { category: "Team Beta", value: 66 },
	    { category: "Team Gamma", value: 82 }
	  ],
	  floor: [
	    { category: "Floor 1", value: 55 },
	    { category: "Floor 2", value: 62 },
	    { category: "Floor 3", value: 74 }
	  ],
	  spaceType: [
	    { category: "Meeting Room", value: 80 },
	    { category: "Desk", value: 68 },
	    { category: "Booth", value: 72 }
	  ]
	};
	
	const openDrawer = (title) => {
		setSelectedName(title);
		setDrawerOpen(true);
	}
	
	

	return (
			<FilterableDashboardTemplate
				title="Worksetting Performance"
				childDashboards={childDashboardsUtilisation}
				filter={filter}
				setFilter={setFilter}>
				<DashboardRow>

				  <div style={CARD_STYLE_STRETCH} onClick={() => setSelectedMetric(METRIC_ACCURACY)}>
				    <AmChartRingIndicator
				      id="kpi_accuracy"
				      percentage={82}
				      width={120}
				      height={120}
					  label={METRIC_CONFIG[METRIC_ACCURACY].label}
					  color={METRIC_CONFIG[METRIC_ACCURACY].color}
					  metric={METRIC_ACCURACY}
				      selectedMetric={selectedMetric}
				    />
				  </div>

				  <div style={CARD_STYLE_STRETCH} onClick={() => setSelectedMetric(METRIC_NO_SHOW)}>
				    <AmChartRingIndicator
				      id="kpi_noshow"
				      percentage={18}
				      width={120}
				      height={120}
					  label={METRIC_CONFIG[METRIC_NO_SHOW].label}
					  color={METRIC_CONFIG[METRIC_NO_SHOW].color}
					  metric={METRIC_NO_SHOW}
				      selectedMetric={selectedMetric}
				    />
				  </div>

				  <div style={CARD_STYLE_STRETCH} onClick={() => setSelectedMetric(METRIC_WORKSTATION)}>
				    <AmChartRingIndicator
				      id="kpi_workstation"
				      percentage={64}
				      width={120}
				      height={120}
					  label={METRIC_CONFIG[METRIC_WORKSTATION].label}
					  color={METRIC_CONFIG[METRIC_WORKSTATION].color}
					  metric={METRIC_WORKSTATION}
				      selectedMetric={selectedMetric}
				    />
				  </div>

				  <div style={CARD_STYLE_STRETCH} onClick={() => setSelectedMetric(METRIC_EFFICIENCY)}>
				    <AmChartRingIndicator
				      id="kpi_efficiency"
				      percentage={71}
				      width={120}
				      height={120}
					  label={METRIC_CONFIG[METRIC_EFFICIENCY].label}
					  color={METRIC_CONFIG[METRIC_EFFICIENCY].color}
					  metric={METRIC_EFFICIENCY}
				      selectedMetric={selectedMetric}
				    />
				  </div>
				  <div style={{ flex: 1.5 }}>
				      <KpiSummaryPanel />
				    </div>
				</DashboardRow>
				<DashboardRow>
				  <MetricInsightBar selectedMetric={selectedMetric} />
				</DashboardRow>
				<DashboardRow>
					<div style={{flex:2, alignItems:'stretch'}}>
					<DashboardCarousel>
						<ChartCard title="By Day Of Week">
							<AmBarChart
						      id="dow_chart"
						      data={dayOfWeekData}
							  chartColor={METRIC_CONFIG[selectedMetric].color}
						    />
						</ChartCard>
						<ChartCard title="Daily Profile">
							<AmBarChart
						      id="hod_chart"
						      data={hourOfDayData}
							  chartColor={METRIC_CONFIG[selectedMetric].color}
						    />
						</ChartCard>
						
						<GroupByChart
						   dataMap={groupByData}
						   color={METRIC_CONFIG[selectedMetric].color}
						   clickFunction={openDrawer}
						 />
						
						<OffendersChart
						   data={offendersData}
						   color={METRIC_CONFIG[selectedMetric].color}
						 />

						 <TopBottomChart
						   dataMap={topBottomData}
						   color={METRIC_CONFIG[selectedMetric].color}
						 />

						

					</DashboardCarousel>
					</div>
					<div style={{flex:1}}>
						<ChartCard title="Activity Heatmap">
						   <AmHeatmapChart
						     id="heatmap_chart"
						     data={heatmapData}
						     color={METRIC_CONFIG[selectedMetric].color}
						   />
						 </ChartCard>
					</div>
				</DashboardRow>
				<DashboardRow>
					<ChartCard title="Timeline">
						<BookingUtilisationTimelineDemo/>
					</ChartCard>
				</DashboardRow>
				<RightDrawer
				  open={drawerOpen}
				  title={selectedName || "Details"}
				  onClose={() => setDrawerOpen(false)}
				>
				  <div>
				    Showing data for: <strong>{selectedName}</strong>
				  </div>
				  <WorksettingPerformanceDrawer/>
				</RightDrawer>
			</FilterableDashboardTemplate>
	);
	
	
	function KpiSummaryPanel() {
	  return (
	    <div style={panelStyle}>

	      <div style={rowStyle}>
	        <KpiStat label="Bookings" value="1,248" />
	        <KpiStat label="No Shows" value="224" />
	      </div>

	      <div style={divider}></div>

	      <div style={rowStyle}>
	        <KpiStat label="Walk Ins" value="312" />
	        <KpiStat label="Worksettings" value="89" />
	      </div>

	    </div>
	  );
	}
	 
	function KpiStat({ label, value }) {
	  return (
	    <div style={{
	      flex: 1,
	      display: "flex",              // 🔥 REQUIRED
	      flexDirection: "column",      // stack value + label
	      alignItems: "center",         // horizontal centre
	      justifyContent: "center",     // vertical centre (nice touch)
	      textAlign: "center"           // ensures text is centred
	    }}>
	      <div style={{
	        color: "#fff",
	        fontSize: "20px",
	        fontWeight: "600"
	      }}>
	        {value}
	      </div>
	      <div style={{
	        color: "rgba(255,255,255,0.6)",
	        fontSize: "12px",
	        marginTop: "4px"
	      }}>
	        {label}
	      </div>
	    </div>
	  );
	}
	
	
	function OffendersChart({ data, color }) {
	  return (
	    <ChartCard title="Top Offenders">
	      <AmBarChart
	        id="offenders_chart"
	        data={data}
	        chartColor={color}
	        maxBars={10}
			horizontal={true}
	      />
	    </ChartCard>
	  );
	}
	
	function TopBottomChart({ dataMap, color }) {

	  const [groupBy, setGroupBy] = useState("room");
	  const [mode, setMode] = useState("top");

	  const data = dataMap[groupBy]?.[mode] || [];

	  return (
	    <ChartCard
	      title="Top / Bottom"
	      rightContent={
	        <ModeSwitch mode={mode} setMode={setMode} />
	      }
	    >

	     

	      {/* CHART */}
	      <AmBarChart
	        id="top_bottom_chart"
	        data={data}
	        chartColor={color}
			horizontal={true}
	      />
		  
		  {/* TABS */}
		        <TabBar
		          options={["room", "team", "floor", "type"]}
		          value={groupBy}
		          onChange={setGroupBy}
		        />

	    </ChartCard>
	  );
	}
	
	
	function ModeSwitch({ mode, setMode }) {
	  return (
	    <div style={switchContainer}>
	      <div
	        style={{
	          ...switchItem,
	          ...(mode === "top" && activeSwitch)
	        }}
	        onClick={() => setMode("top")}
	      >
	        Top
	      </div>
	      <div
	        style={{
	          ...switchItem,
	          ...(mode === "bottom" && activeSwitch)
	        }}
	        onClick={() => setMode("bottom")}
	      >
	        Bottom
	      </div>
	    </div>
	  );
	}
	
	
	function GroupByChart({ dataMap, color }) {

	  const [groupBy, setGroupBy] = useState("department");

	  const data = dataMap[groupBy] || [];

	  return (
	    <ChartCard title="Group By">

	     

	      {/* CHART */}
	      <AmBarChart
	        id="groupby_chart"
	        data={data}
	        chartColor={color}
			clickFunction={openDrawer}
	      />
		  {/* TABS */}
		        <TabBar
		          options={["department", "team", "floor", "spaceType"]}
		          value={groupBy}
		          onChange={setGroupBy}
		        />
	    </ChartCard>
	  );
	}
	
	
	function TabBar({ options, value, onChange }) {
	  return (
	    <div style={tabContainer}>
	      {options.map(opt => (
	        <div
	          key={opt}
	          onClick={() => onChange(opt)}
	          style={{
	            ...tab,
	            ...(value === opt && activeTab)
	          }}
	        >
	          {opt}
	        </div>
	      ))}
	    </div>
	  );
	}
	
}